import React from "react";
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import BannerText from './components/bannerText/BannerText';
import Slider from './components/slider/Slider';
import About from './components/aboutUs/About';
import Services from './components/services/Services';
import Dentists from './components/dentists/Dentists';
import Partners from './components/partners/Partners';
import Contact from './components/contact/Contact';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <div className="app">
      
      <Header/>
      <Slider/>
      <BannerText/>
      <About/>
      <Services/>
      <Dentists/>
      <Partners/>
      <Contact/>
    
      <Footer/>
      

      
      
      
      
      
    </div>
  );
}

export default App;
